import React from 'react';

import { UserAgentProvider } from '@quentin-sommer/react-useragent';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { useStore } from '../global-states/store';

import '../styles/global.css';

export default function App({
  Component,
  pageProps,
}: {
  Component: any;
  pageProps: any;
}) {
  const { store, persistor } = useStore(pageProps.initialReduxState);
  const { basePath } = useRouter();

  return (
    <>
      <UserAgentProvider
        ua={
          typeof window === 'object' ? (window as any).navigator.userAgent : ''
        }
      >
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <title>RushOwl - Live Journey Tracking</title>
          {/* basePath-aware icons: the app is served under /safety, so the
              browser's default /favicon.ico request 404s without these.
              Keys match layout/Meta.tsx so page-level Meta overrides dedupe. */}
          <link
            rel="apple-touch-icon"
            href={`${basePath}/apple-touch-icon.png`}
            key="apple"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href={`${basePath}/favicon-32x32.png`}
            key="icon32"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href={`${basePath}/favicon-16x16.png`}
            key="icon16"
          />
          <link rel="icon" href={`${basePath}/favicon.ico`} key="favicon" />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" />
          <link
            href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"
            rel="stylesheet"
          />
        </Head>

        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Component {...pageProps} />
          </PersistGate>
        </Provider>
      </UserAgentProvider>
    </>
  );
}
